import { apiBaseURL, toastifyType } from "../../../constant"
import apiConfig from "../../../config/apiConfig"
import { addTost } from "../../actions/toastAction"
import { setLoading } from "../../actions/loadingAction"

export const sendResetLink = (email, setIsLoading) => async (dispatch) => {
    try {
        setIsLoading(true);
        const response = await apiConfig.post(apiBaseURL.FORGOT_PASSWORD, { email });
        dispatch(addTost({ type: toastifyType.SHOW_SUCCESS_MESSAGE, message: response?.data?.message }));
        setIsLoading(false);
        return response?.data;
    } catch (error) {
        console.error(error);
        setIsLoading(false);
        const axiosError = error;
        const errorMessage = axiosError.response?.data?.errors || "Something went wrong";
        dispatch(addTost({ type: toastifyType.SHOW_ERROR_MESSAGE, message: errorMessage }));
    }
};


export const resetPassword = (password, token, navigate) => async (dispatch) => {
    try {
        dispatch(setLoading(true));
        const response = await apiConfig.post(apiBaseURL.RESET_PASSWORD, { password, token });
        if (response?.data?.success) {
            dispatch(addTost({ type: toastifyType.SHOW_SUCCESS_MESSAGE, message: response.data.message }));
            navigate('/login', { replace: true });
        }
        dispatch(setLoading(false));
    } catch (error) {
        dispatch(setLoading(false));
        dispatch(addTost({ type: toastifyType.SHOW_ERROR_MESSAGE, message: error.response.data.message }));
        console.error(error);
    }
};

